/**
 * Respuesta de GET Turnos/preparacion-practica: texto plano y/o fragmentos HTML.
 */
export function looksLikeHtmlString(s) {
  const t = String(s ?? '').trim()
  if (!t) return false
  return /<[a-z][\s\S]*>/i.test(t)
}

/** Mitigación básica antes de v-html (contenido institucional del backend). */
export function stripUnsafeHtmlFragment(html) {
  return String(html ?? '')
    .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '')
    .replace(/\son\w+\s*=\s*(['"])[\s\S]*?\1/gi, '')
    .replace(/\son\w+\s*=\s*[^\s>]+/gi, '')
}

function escapeHtmlText(s) {
  return String(s ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

/**
 * @returns {{ contenido: string, esHtml: boolean }}
 */
export function preparacionDesdeRespuestaApi(data) {
  if (data == null) return { contenido: '', esHtml: false }

  if (typeof data === 'string') {
    const t = data.trim()
    if (!t) return { contenido: '', esHtml: false }
    if (looksLikeHtmlString(t)) {
      return { contenido: stripUnsafeHtmlFragment(t), esHtml: true }
    }
    if ((t.startsWith('{') && t.endsWith('}')) || (t.startsWith('[') && t.endsWith(']'))) {
      try {
        return preparacionDesdeRespuestaApi(JSON.parse(t))
      } catch {
        return { contenido: t, esHtml: false }
      }
    }
    return { contenido: t, esHtml: false }
  }

  if (typeof data !== 'object') {
    return { contenido: String(data), esHtml: false }
  }

  const root = data?.data ?? data
  if (!root || typeof root !== 'object') {
    return { contenido: '', esHtml: false }
  }

  const pick = (...keys) => {
    for (const k of keys) {
      const v = root[k]
      if (typeof v === 'string' && v.trim()) return v.trim()
    }
    return ''
  }

  const htmlBlock = pick(
    'htmlPreparacionServicioDefault',
    'htmlPreparacion',
    'preparacionHtml',
    'html',
    'contenidoHtml',
  )

  const practica = pick('preparacionPractica', 'texto')

  if (practica && looksLikeHtmlString(practica)) {
    const rest = htmlBlock && htmlBlock !== practica ? htmlBlock : ''
    const merged = rest ? `${practica}\n${rest}` : practica
    return { contenido: stripUnsafeHtmlFragment(merged), esHtml: true }
  }

  if (htmlBlock) {
    if (practica && !looksLikeHtmlString(practica)) {
      const wrapped = `<p class="mb-2 text-body-2">${escapeHtmlText(practica)}</p>${htmlBlock}`
      return { contenido: stripUnsafeHtmlFragment(wrapped), esHtml: true }
    }
    return {
      contenido: stripUnsafeHtmlFragment(htmlBlock),
      esHtml: looksLikeHtmlString(htmlBlock),
    }
  }

  if (practica) {
    return {
      contenido: practica,
      esHtml: looksLikeHtmlString(practica),
    }
  }

  const tieneCamposPreparacion = [
    'htmlPreparacionServicioDefault',
    'htmlPreparacion',
    'preparacionHtml',
    'html',
    'contenidoHtml',
    'preparacionPractica',
    'texto',
  ].some((k) => Object.prototype.hasOwnProperty.call(root, k))

  if (tieneCamposPreparacion) {
    return { contenido: '', esHtml: false }
  }

  try {
    return { contenido: JSON.stringify(data), esHtml: false }
  } catch {
    return { contenido: '', esHtml: false }
  }
}
